import React, { useState } from 'react';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { isEdge, isFirefox } from 'react-device-detect';
import chromeHelp from '../../images/download-chrome.png';
import firefoxHelp from '../../images/download-firefox.png';
import edgeHelp from '../../images/download-edge.png';

const useStyles = makeStyles({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '80px',
    padding: '16px 24px 24px 24px',
  },
  title: {
    maxWidth: '450px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '26px',
    lineHeight: '30px',
    textAlign: 'left',
    color: '#0947B9',
  },
  buttonContainer: {
    padding: '0px 24px 24px 24px',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    height: '32px',
    borderWidth: '2px',
    boxShadow: 'none',
  },
});

interface Props {
  open: boolean;
  /**
   * Closing this dialog is the only way out of it: the BFX file has already been downloaded by the
   * time it is shown, so backing out would only strand the user with a file and no way to post the
   * markups.
   */
  handleContinue: () => void;
  filename?: string;
}

export default function BluebeamLaunchDialog(props: Props) {
  const classes = useStyles();
  const { open, handleContinue, filename } = props;

  // The browser screenshots are different sizes, so the dialog is sized from whichever one is
  // shown rather than from a hardcoded width.
  const [imageWidth, setImageWidth] = useState<number>();

  const getInstructions = () => {
    if (isFirefox) {
      return firefoxHelp;
    }

    if (isEdge) {
      return edgeHelp;
    }

    return chromeHelp;
  };

  return (
    <Dialog open={open} PaperProps={{ style: { width: 'fit-content' } }}>
      <DialogTitle className={classes.titleContainer} style={{ height: 'auto', paddingBottom: 0 }}>
        <Typography className={classes.title}>Bluebeam Auto Launch?</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography style={{ marginBottom: 16, maxWidth: imageWidth }}>
          If Bluebeam does not automatically launch, double click{' '}
          <strong>
            {filename ? `${filename.substring(0, filename.indexOf('.'))}.bfx` : 'the BFX file'}
          </strong>{' '}
          in your downloads folder. For instructions to change your browser settings so Bluebeam
          automatically launches, see below.
        </Typography>
        <img
          src={getInstructions()}
          alt="download help"
          style={{ display: 'block' }}
          onLoad={(event) => setImageWidth(event.currentTarget.offsetWidth)}
        />
      </DialogContent>
      <DialogActions className={classes.buttonContainer}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(event, checked) => {
                if (checked) {
                  localStorage.setItem('skipBluebeamHelp', 'true');
                } else {
                  localStorage.removeItem('skipBluebeamHelp');
                }
              }}
            />
          }
          label="Don't show this again"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleContinue}
          className={classes.button}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
